import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueAgile from 'vue-agile'
import axios from 'axios'
import VModal from 'vue-js-modal'

axios.defaults.baseURL = 'https://mail.ng-constructioninc.com/api/'
Vue.use(VModal)
Vue.use(VueAgile)

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
